import createContextProxy from 'src/state/context/contextProxy'
import type { SlideSettingsStateType } from './SlideSettingsProvider';

const slideSettingsProvider = createContextProxy<SlideSettingsStateType>('SlideSettings')

export const SlideSettingsStateContext = slideSettingsProvider.ContextProxy
export const SlideSettingsStateProvider = slideSettingsProvider.ContextProxyProvider
export const useSlideSettingsState = slideSettingsProvider.useProxy
